import GeniusCarouselWrapper from './GeniusCarouselWrapper';
import { connect } from './connect';

export default connect(GeniusCarouselWrapper);
